import { RepositoryFactory } from "@/Apicall/RepositoryFactory";
const testimonial = RepositoryFactory.get("portfolioTestimonial");

export default {
  create({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await testimonial.create(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  get({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await testimonial.get(payload);
        commit("SET_TESTIMONIAL", data.data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  update({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await testimonial.update(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  delete({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await testimonial.delete(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
